<app-menu-riot></app-menu-riot>
<div class="content">
    <div class="logo">
        <img src="https://playforgood.io/wp-content/uploads/2021/04/logo-teamfight-tactis.png"
             alt="logo-teamfight-tactics">
    </div>
    <div class="tft-info">
        <div class="container">
            <p><a href="https://teamfighttactics.leagueoflegends.com/fr-fr/" target="_blank">Teamfight Tactics</a>
                (abrégé TFT) est un jeu vidéo de type auto battler sorti le 26 juin 2019, développé et
                édité par <a href="https://www.riotgames.com/fr" target="_blank">Riot Games</a>. Il prend place dans
                l’univers de League of Legends et est basé sur le jeu Dota
                Auto Chess.
            </p>
            <p>Le jeu fonde son gameplay sur le fait de former une équipe qui affrontera, tour après tour, celle des
                sept autres joueurs.
            </p>
            <p>Cette équipe est composée de champions de League of Legends recrutables au fil de la partie, chacun
                disposant d’une compétence unique et d’une « classe » ainsi que d’une « origine » propre. Un certain
                nombre de champions de la même classe, ou de la même origine, réuni dans la même équipe, confère
                différents bonus au joueur.
            </p>
            <p>L’économie étant aussi un point central du jeu, les joueurs et joueuses doivent faire preuve de stratégie
                afin de remporter la partie !
            </p>
            <p>Source : <a href="https://fr.wikipedia.org/wiki/Teamfight_Tactics" target="_blank">Wikipedia</a></p>
            <p>Les règles du tournoi TFT organisé par le Play For Good #2 : <a
                href="https://docs.google.com/document/d/1ffjQtLRuMMvKG1Le4FfFlETz_69OuiVA/edit" target="_blank">ICI</a>
            </p>
        </div>
    </div>
    <div class="widget">
        <div class="widget-content">
            <h5>Information et inscription</h5>
            <iframe width="80%" height="360"
                    src="https://widget.toornament.com/tournaments/4559342603735793664/?_locale=fr"
                    allowfullscreen frameborder="0"></iframe>
        </div>
        <div class="widget-content">
            <h5>Calendrier des games</h5>
            <iframe width="80%" height="360"
                    src="https://widget.toornament.com/tournaments/4559342603735793664/matches/schedule/?_locale=fr"
                    frameborder="0"></iframe>
        </div>
        <div class="widget-content">
            <h5>Arbres du tournoi</h5>
            <iframe width="80%" height="360"
                    src="https://widget.toornament.com/tournaments/4559342603735793664/stages/4559436222389100544/?_locale=fr"
                    allowfullscreen frameborder="0"></iframe>
        </div>
    </div>
</div>

<app-scroll-to-top></app-scroll-to-top>
<app-footer></app-footer>
